var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInprogressSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9935 1.33334C4.3135 1.33334 1.3335 4.32001 1.3335 8.00001C1.3335 11.68 4.3135 14.6667 7.9935 14.6667C11.6802 14.6667 14.6668 11.68 14.6668 8.00001C14.6668 4.32001 11.6802 1.33334 7.9935 1.33334ZM8.00016 13.3333C5.0535 13.3333 2.66683 10.9467 2.66683 8.00001C2.66683 5.05334 5.0535 2.66668 8.00016 2.66668C10.9468 2.66668 13.3335 5.05334 13.3335 8.00001C13.3335 10.9467 10.9468 13.3333 8.00016 13.3333Z",
    fill: "#43494F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 4.66668H7.3335V8.66668L10.8335 10.7667L11.3335 9.94668L8.3335 8.16668V4.66668Z",
    fill: "#43494F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInprogressSm);
export default __webpack_public_path__ + "static/media/icon_inprogress_sm.712cfcc4a07d1503f0fea4baace30b0a.svg";
export { ForwardRef as ReactComponent };